import { render, staticRenderFns } from "./InterBankTransfer.vue?vue&type=template&id=045bc32d&scoped=true&"
import script from "./InterBankTransfer.vue?vue&type=script&lang=js&"
export * from "./InterBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045bc32d",
  null
  
)

export default component.exports